import { Empty } from 'antd';
import { FC } from 'react';
import { AspectRatio } from 'react-bootstrap-icons';

const NotFoundDrawerPage: FC = () => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
      <Empty style={{ opacity: 0.3 }} description="Виберіть елемент" image={ <AspectRatio size={ 50 }/> }/>
    </div>
  );
};

export default NotFoundDrawerPage;
